module.exports = __webpack_public_path__ + "img/slide-6.8169e633.jpg";